import { render, staticRenderFns } from "./uploads.vue?vue&type=template&id=18b60715&scoped=true&"
import script from "./uploads.vue?vue&type=script&lang=js&"
export * from "./uploads.vue?vue&type=script&lang=js&"
import style0 from "./uploads.vue?vue&type=style&index=0&id=18b60715&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b60715",
  null
  
)

export default component.exports